// extracted by mini-css-extract-plugin
export default {"employee":"Employee_employee__LJIrW"};